import { TPageNotification } from '../../../types/common';

export const PAGE_SIZE_OPTIONS = [20, 50, 100];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];

export const PAGE_SELECTION_STATE = {
    NONE: 'none',
    SOME: 'some',
    ALL: 'all',
} as const;

export type TPageSelectionState =
    typeof PAGE_SELECTION_STATE[keyof typeof PAGE_SELECTION_STATE];

export const REBOOKS_EXTENDING_TYPE = {
    ALL: 'all',
    SELECTED: 'selected',
} as const;

export type TRebooksExtendingType =
    | typeof REBOOKS_EXTENDING_TYPE[keyof typeof REBOOKS_EXTENDING_TYPE]
    | null;

export type TRebooksProps = {
    notification: TPageNotification;
};

type TPerson = {
    id: number;
    reference_number: string;
    first_name: string;
    last_name: string;
};

export type TFreelancer = TPerson & {
    photo_thumbnail_large: string | null;
};

export type TJob = {
    id: number;
    reference_number: string;
    title: string;
    date: string;
    start_time: string;
    duration: string;
    address1: string;
    city: string;
};

export type TClient = TPerson & {
    company_name: string;
};

export type TRebook = {
    id: number;
    status: string;
    is_series: boolean;
    is_next_week_free: boolean;
    busy_bookings?: {
        id: number;
        reference_number: string;
        job_id?: number;
        job_reference_number?: string;
        date?: string;
        blocking_bookings?: {
            id: number;
            reference_number: string;
            job_id?: number;
            job_reference_number: string;
            job_title: string;
            job_address: string;
            job_city: string;
            date: string;
            client_name: string;
            client_reference_number: string;
        }[];
    }[];
    free_bookings?: {
        id: number;
        reference_number: string;
        job_id?: number;
        job_reference_number?: string;
        date?: string;
    }[];
    end_date: string;
    freelancer: TFreelancer;
    job: TJob;
    client: TClient;
};

export type TValueLabelOption<T = string> = {
    value: T;
    label: string;
};

export type TFilterOptions = {
    ordering: TValueLabelOption[];
    is_series: TValueLabelOption<boolean>[];
    availability: TValueLabelOption[];
    defaults: Record<string, string>;
};
